import { createGlobalStyle } from 'styled-components'
import { normalize } from 'styled-normalize'

import { BASE_FONT_SIZE } from './constants'
import { loadScreenStyles } from './loadScreen'
import { color, fontFamily, fontWeight } from './utils'

export const GlobalStyle = createGlobalStyle`
  ${normalize};

  user-select: none;
  -webkit-user-select: none;
  
  #root {
    margin: 0 auto;
  }

  *, *:before, *:after {
    box-sizing: border-box;
    overscroll-behavior: none;
    touch-action: none;
    user-select: none;
    -webkit-user-select: none;
  }

  html, body{
    min-height: 100vh;
    min-height: var(--vh);
    min-height: 100dvh;
    text-size-adjust: none;
  }

  html {
    font-size: ${BASE_FONT_SIZE}px;
    overscroll-behavior: none;
  }

  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    font-family: ${fontFamily('base')};
    font-weight: ${fontWeight('base')};
    background: ${color('background')};
    color: ${color('text')};
    line-height: 1.5;

    /* scrollbar-gutter: stable; */
    /* overflow-y: scroll; */
  }

  *:focus-visible {
    outline: none;
  }
  
  .animation--overflow--hidden {
    overflow-x: hidden;
    overflow-y: hidden;
    // Do this to prevent mid navigation animation interactions because we don't want that jank.
    pointer-events: none;
  }

  .overflow--hidden{
    overflow:hidden;
  }


  figure, fieldset {
    padding:0;
    margin:0;
  }

  fieldset{
    border: 0;
  }
  
  button {
    cursor: pointer;
    background:none;
    border:0;
    appearance: none;
  }

  svg {
    flex-basis: 100%;
  }
  
  li {
    margin:0 0 1rem 0;
  }

  p {
    line-height: 1.5;
    margin: 0 0 1rem 0;
  }

  a {
    color: ${color('interactive')};
    text-decoration: none;
    font-weight: ${fontWeight('base')};
  }

  hr {
    height:0;
    margin: 1rem 0;
    width: 100%;
    border: none;
    border-bottom: 1px solid ${color('text')};
  }

  ul, ol {
    margin: 0 0 1rem 0;
    padding: 0 0 0 1rem;
  }

  h1, h2, h3, h4, h5, h6 {
    color: ${color('text')};
    margin:0;
  }
  

  .no-js-message{
    text-align: center;
    padding: 20px;
    background: salmon;
    margin: 0 20px;
    border-radius: 4px;
    border: 1px solid salmon;
    box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.08);
  }


  #modal-root {
    position: relative;
    z-index: 1000;
  }

  .animator {
    height: 100%;
    width: 100%;
  }

  // Component styles that we want loaded globally as instantly as possible
  ${loadScreenStyles} // Used for the app loading screen

`
